import React, { FC } from 'react';
import DOMPurify from 'dompurify';

interface HtmlContentProps {
  htmlString: string;
  keyword?: string;
  highlightMT?: string;
  component?: 'span' | 'div';
}

const HtmlContent: FC<HtmlContentProps> = ({
  htmlString,
  keyword,
  highlightMT,
  component = 'span'
}) => {
  const highlightKeyword = (text: string) => {
    const regex = new RegExp(`(${keyword}|${highlightMT})`, 'gi');
    return text.replace(regex, '<span style="background-color: yellow">$1</span>');
  };
  const sanitizedHtmlString = DOMPurify.sanitize(htmlString, { ADD_ATTR: ['target'] });
  const highlightedHtmlString =
    keyword || highlightMT ? highlightKeyword(sanitizedHtmlString) : sanitizedHtmlString;
  return component === 'div' ? (
    <div dangerouslySetInnerHTML={{ __html: highlightedHtmlString }} />
  ) : (
    <span dangerouslySetInnerHTML={{ __html: highlightedHtmlString }} />
  );
};

export default HtmlContent;
